// extracted by mini-css-extract-plugin
export default {"wrapper":"NavbarAdmin_wrapper__duSG6","wrapper_nav":"NavbarAdmin_wrapper_nav__EXyFQ","item_nav":"NavbarAdmin_item_nav__q8QPV"};